<template>
  <div class="facets-type-search">
    <input :value="selectedEntry" type="text" @input="getEntries" />
    <ul v-if="entriesLength" class="facets-type-search__dropdown">
      <template v-for="(entry, key, index) in entries">
        <li v-if="entry.length" :key="JSON.stringify(entry)">
          <div v-if="entriesLength > 1" class="facets-type-search__title">
            {{ getTitle(key, index) }}
          </div>
          <ul class="facets-type-search__list">
            <template v-for="item in entry">
              <li
                :key="item.default"
                v-html="item.markup"

                @click="selectEntry(item.default, key)"
              />
            </template>
          </ul>
        </li>
      </template>
    </ul>
</div>
</template>

<script>
export default {
  name: 'FacetsTypeSearch',

  props: {
    type: {
      type: Array,
      required: true,
    },

    name: {
      type: Array,
      required: false,
      default: () => [],
    },

    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      entries: {},
      selectedEntry: '',
    };
  },

  computed: {
    allValues() {
      const obj = {};

      Object.keys(this.options).forEach((key) => {
        obj[key] = this.options[key].map((option) => option.value);
      });

      return obj;
    },

    entriesLength() {
      return Object.keys(this.entries).length;
    },
  },

  methods: {
    getTitle(key, index) {
      return this.name[index] || key;
    },

    selectEntry(entry, key) {
      this.selectedEntry = entry;
      this.entries = [];

      this.emitFacet(entry, key);
    },

    addMarkup(string, start, end) {
      return string.slice(start, end);
    },

    getEntries({ target }) {
      const value = target.value.toLowerCase().trim();

      this.selectedEntry = target.value;

      if (!value.length) {
        Object.keys(this.allValues).forEach((key) => {
          this.emitFacet('', key);
        });
      }

      if (value.length < 2) {
        this.entries = [];

        return;
      }

      const entryList = {};

      Object.keys(this.allValues).forEach((key) => {
        if (!entryList[key]) {
          entryList[key] = [];
        }

        const newEntries = this.allValues[key].filter(
          (entry) => entry.toLowerCase().indexOf(value) > -1,
        );

        newEntries.forEach((entry) => {
          const startIndex = entry.toLowerCase().indexOf(value);
          const endIndex = startIndex + value.length;
          const replacementString = this.addMarkup(entry, startIndex, endIndex);

          entryList[key].push(
            {
              default: entry,
              markup: entry.replace(replacementString, `<strong>${replacementString}</strong>`),
            },
          );
        });
      });

      this.entries = entryList;
    },

    emitFacet(value, key) {
      Object.keys(this.allValues).forEach((listKey) => {
        if (listKey !== key) {
          this.$emit('selected', { value: '', key: listKey });
        }
      });

      this.$emit('selected', { value, key });
    },
  },
};
</script>

<style lang="scss" scoped>
  .facets-type-search {
    position: relative;

    input {
      width: 100%;
    }

    &__dropdown {
      background-color: $color-white;
      left: 0;
      margin: 0;
      max-height: 300px;
      overflow: hidden;
      overflow-y: auto;
      padding: 0;
      position: absolute;
      right: 0;
      top: 100%;
      z-index: get-z-index();

      ul, li {
        list-style: none;
        margin: 0;
        padding: 0;
      }
    }

    &__title {
      padding: $global-spacing-unit-quarter 0;
    }

    &__list {
      @include font-size(iota);

      li {
        cursor: pointer;
        padding: $global-spacing-unit-quarter $global-spacing-unit-half;

        &:nth-of-type(odd) {
          background-color: rgba($color-black, .05);
        }

        &:hover {
          background-color: rgba($color-black, .13);
        }
      }
    }
  }
</style>
